import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingIncludedContent } from '../../../../hooks/useVpsHostingIncludedContent';
import checkIcon from '../../../../assets/images/vpshosting/included/CheckCircle.svg';
import './Included.css';

const Included = () => {
  const { content, isLoading } = useVpsHostingIncludedContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, checkIcon: checkIconUrl, items } = content;

  return (
    <section className="vps-hosting-included">
      <div className="vps-hosting-included__inner">
        <div className="vps-hosting-included__panel">
          <Reveal>
            <h2 className="vps-hosting-included__title">{title}</h2>
          </Reveal>

          <div className="vps-hosting-included__grid">
            {items.map((item, index) => (
              <Reveal key={item} delay={index * 50}>
                <div className="vps-hosting-included__item">
                  <img
                    className="vps-hosting-included__icon"
                    src={checkIconUrl || checkIcon}
                    alt=""
                    aria-hidden="true"
                  />
                  <span className="vps-hosting-included__text">{item}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Included;
